module.exports = __webpack_public_path__ + "img/general.182c3b82.svg";